/* raw layout hash: _default-web-layout-cevls9:79b24744bef373d27bfea8125da991bface19fa0a4d02bbcbd59b2d77c42f699 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_default-web-layout-cevls9" — renders its page content through the router outlet.
export default function DefaultWebLayoutCevls9() {
  return <AppShell layoutName="_default-web-layout-cevls9" menu={LAYOUT_MENUS['_default-web-layout-cevls9']} />;
}
